import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClosingSection() {
  return <section className="w-full bg-bg-alt py-16 md:py-24 px-4" data-id="element-21">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-22">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-text-primary" data-id="element-23">
          Tu cuerpo no es el problema.{' '}
          <span className="text-accent" data-id="element-24">Es tu mejor herramienta.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-25">
          Hoy puedes empezar a entenderlo. Hoy puedes dejar de luchar contigo
          misma. Esta guía es el primer paso.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-26">
          <a href="#comprar" className="inline-block bg-primary text-white px-10 py-5 rounded-full text-xl font-medium shadow-xl hover:bg-accent transition-colors" data-id="element-27">
            Empezar hoy
          </a>
        </motion.div>
      </div>
    </section>;
}